// extracted by mini-css-extract-plugin
export default {"root":"ProfileNav_root__esvoO","nav":"ProfileNav_nav__3JjOp","link":"ProfileNav_link__Y+3ai h4","linkSelected":"ProfileNav_linkSelected__QqdG1"};